export enum SentneceDrawerStatus {
    ADD_SENTENCE_OPEN,
    ADD_SENTENCE_CLOSE,
    EDIT_SENTENCE_OPEN,
    EDIT_SENTNECE_CLOSE,
    NOT_OPENED
}